package com.mshopsas.enterprise.aiw.scan.utils

actual val platform: String
    get() = "WEB"